// extracted by mini-css-extract-plugin
export default {"clientTheme":"App_clientTheme__h7TOt"};